export default __webpack_public_path__ + "static/media/img_baseCrochet_rose_p.30183ea6.jpg";